export const Quiz = {
	Question: 'Question {{currentQuestion}}',
	'Question of': 'Question {{currentQuestion}} of {{totalQuestions}}',
	Answer: 'Answer',
	Saving: 'Saving...',
	'Saving...': 'Saving...',
	'Click on the Finish button to see the score of the quiz.':
		'Click the Finish button to grade your quiz.',
	'Finish quiz': 'Finish',
	'Quiz result': 'Quiz results',
	'Passed exam': 'Passed',
	'Failed exam': 'Failed',
	'Total Questions': 'Number of questions',
	Correct_one: 'Correct',
	Correct_other: 'Correct',
	Incorrect_one: 'Incorrect',
	Incorrect_other: 'Incorrect',
	'% of Correct': '% correct',
	Score: 'Score',
	Next: 'Next',
	'This quiz has a time limit to answer, after that it will finish automatically.':
		'This quiz has a time limit to answer, after which it will finish automatically.',
	'Start your quiz': 'Start your quiz',
	'Time end': 'Time is up',
	minutes: 'minutes',
	'Retry confirm title': 'Restart the quiz?',
	'Retry confirm text':
		'Your current score ({{score}}%) will be erased and a new attempt will start from scratch.',
	'Retry confirm yes': 'Yes, retry',
	'Retry confirm cancel': 'Cancel',
	'Time end calculating': 'Time is up, calculating result…',
	'Error saving the quiz.': 'There was an error while saving the quiz.',
	'Answer save error title': 'There was a problem',
	'Answer save error text': 'We could not save your answer. Please try again.',
	'Answer save persistent error title': 'The problem persists',
	'Answer save persistent error text':
		'We still cannot save your answer. Please try again later.',
	Understood: 'Got it',
	Paused: 'Paused',
	'Face ID required': 'Identity validation required',
	'Face ID alert title': 'Heads up: This quiz requires a camera',
	'Face ID alert text':
		'Before you start, make sure your phone or computer has a camera. During the assessment you will be asked to take a photo of your face. Important: If you do not take the photo, the quiz will be closed.',
	'Validator not configured':
		'Your organization does not have biometric validation configured for this exam. Contact the administrator.',
	'Face ID init failed':
		'Could not start identity validation. Please try again.',
	'Back to course': 'Back to course',
	'Face ID retry title': 'Validation problem',
	'Face ID retry text':
		'Could not complete the identity validation. Please try again.',
	'Attempts remaining: {{n}}': 'Attempts remaining: {{n}}',
	'Face ID attempts exceeded title': 'We could not validate your identity',
	'Face ID attempts exceeded text':
		'For security reasons, your assessment has been closed. To help you resolve this and let you take the quiz, please contact our support team via chat or email at {{email}}.',
	'Finishing quiz': 'Finishing quiz…',
	'Close validation title': 'Close validation?',
	'Close validation text':
		'If you close the validation, the quiz will close and you will return to the course. When you come back, you will need to validate again upon reaching the same question.',
	'Yes, close': 'Yes, close',
	'Continue validating': 'Continue validating',
	Retry: 'Retry',
	Unanswered: 'Unanswered',
	Unanswered_one: 'Unanswered',
	Unanswered_other: 'Unanswered',
	'No answer recorded': 'No answer recorded for this question.',
	Remaining: 'Remaining',
	Resume: 'Summary',
	Feedback: 'Feedback',
	'Quiz feedback': 'Quiz feedback',
	'Go back': 'Go back',
	'The evaluation will be reviewed by the course instructor. We will let you know once the results are available.':
		'The evaluation will be reviewed by the course instructor. We will let you know once the results are available.',
	'Face ID service problems title': 'Identity validation problems',
	'Face ID service problems text':
		'We are having problems with the identity validation service. No attempt was used. You can retry or continue later.',
	'Continue later': 'Continue later',
	'Face ID already enrolled text':
		'You are already enrolled in identity validation. We will validate you again.',
	'Quiz could not be closed':
		'We could not close your quiz right now. Your answers are saved; come back in a few minutes to see your result.',
};
